import { Button, Stack, Typography } from '@mui/material';
import { ListFilterSelectWrapLine } from './common';

interface ListFilterSelectTitleProps {
  title: string;
  onAction?: () => void;
  actionText?: string;
}

export default function ListFilterSelectTitle({ title, onAction, actionText }: ListFilterSelectTitleProps) {
  return (
    <ListFilterSelectWrapLine>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Typography variant="caption">{title}</Typography>
        {onAction && (
          <Button variant="text" size="small" onClick={onAction}>
            {actionText || 'Back'}
          </Button>
        )}
      </Stack>
    </ListFilterSelectWrapLine>
  );
}
